import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Adminsignin.css';
import ENV from '../constants/env-constants';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import Spinner from '../components/Spinner/Spinner';

function Adminsignin() {
  const location = useLocation()
  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Admin Signin Page' });
  }, []);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    setIsButtonLoading(true);
    e.preventDefault();
    try {
      const response = await fetch(`${ENV.API_URL}/api/auth/adminsignin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });
      
      console.log(response)

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.token);
        localStorage.setItem('adminid', data.id);
        // Redirect to dashboard
        navigate('/admindashboard/allusers');
      } else {
        const errorData = await response.json();
        setErrorMessage("Invalid Credentials"); 
      }
    } catch (error) {
      console.error('Login failed:', error);
    }
    setIsButtonLoading(false);
  };


  return (
    <div className="center1">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Admin Log In</title>
        </Helmet>
        <div className="centercustom center">
          <h1>Admin Login</h1>
          <form className='form'>
            <div className="txt_field">
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required  />
              <span />
              <label>Email</label>
            </div>
            <div className="txt_field">
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required  />
              <span />
              <label>Password</label>
            </div>
            <div className="error-message" style={{color:'red'}}>{errorMessage}</div>
            <div onClick={handleSubmit} className='sign-in-submit-button' style={{height: '3rem', display: 'flex', justifyContent: 'center', padding: '0.5rem', alignItems: 'center'}}>
              {isButtonLoading ? <Spinner color="#2691d9"/> : 'Sign in'}
            </div>
          </form>
        </div>
    </div>
  );
}

export default Adminsignin;